import { ACTION } from './actions';
import { xhrRequestReducer } from './../ui/src/reducers';
import {
  transformTvKosiceVideoToStandardArticle,
  getProp,
} from './../ui/src/utilities.js';

const mainmenu = (
  state = {
    isFetching: false,
    data: {
      sections: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.MAINMENU_REQUEST:
    case ACTION.MAINMENU_SUCCESS:
    case ACTION.MAINMENU_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('MAINMENU', state, action),
      );
    default:
      return state;
  }
};

const footermenu = (
  state = {
    isFetching: false,
    data: {
      sections: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.FOOTERMENU_REQUEST:
    case ACTION.FOOTERMENU_SUCCESS:
    case ACTION.FOOTERMENU_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('FOOTERMENU', state, action),
      );
    default:
      return state;
  }
};

const infomixArticles = (
  state = {
    isFetching: false,
    data: {
      nextOffset: null,
      articles: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.INFOMIX_ARTICLES_REQUEST:
    case ACTION.INFOMIX_ARTICLES_SUCCESS:
    case ACTION.INFOMIX_ARTICLES_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('INFOMIX_ARTICLES', state, action),
      );
    default:
      return state;
  }
};

const trafficEntities = (
  state = {
    byId: {},
  },
  action,
) => {
  switch (action.type) {
    case ACTION.TRAFFIC_DETAIL_REQUEST:
      return state;
    case ACTION.TRAFFIC_DETAIL_SUCCESS: {
      let data = {};
      for (let item of action.data) {
        data[item.id] = item.response;
      }

      let byId = Object.assign({}, state.byId, data);

      let newState = Object.assign({}, state, {
        byId,
      });

      return newState;
    }
    case ACTION.TRAFFIC_DETAIL_FAILURE:
      return state;
    default:
      return state;
  }
};

const traffic = (
  state = {
    isFetching: false,
    nextOffset: null,
    items: [],
  },
  action,
) => {
  switch (action.type) {
    case ACTION.TRAFFIC_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.TRAFFIC_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
      });
    case ACTION.TRAFFIC_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.data.items,
        nextOffset: action.data.nextOffset,
      });
    case ACTION.TRAFFIC_LIST_MORE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: [...state.items, ...action.data.items],
        nextOffset: action.data.nextOffset,
      });
    default:
      return state;
  }
};

const homeTraffic = (
  state = {
    isFetching: false,
    items: [],
  },
  action,
) => {
  switch (action.type) {
    case ACTION.HOME_TRAFFIC_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.HOME_TRAFFICFAILURE:
      return Object.assign({}, state, {
        isFetching: false,
      });
    case ACTION.HOME_TRAFFIC_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.data.items,
        nextOffset: action.data.nextOffset,
      });
    default:
      return state;
  }
};

const playlist = (
  state = {
    isFetching: false,
    data: {
      items: [],
    },
    receivedAt: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.PLAYLIST_REQUEST:
    case ACTION.PLAYLIST_SUCCESS:
    case ACTION.PLAYLIST_FAILURE:
      return Object.assign(
        {},
        state,
        xhrRequestReducer('PLAYLIST', state, action),
      );
    default:
      return state;
  }
};

const banners = (
  state = {
    isFetching: false,
    data: {
      content: null,
      static_content: null,
    },
    receivedAt: null,
  },
  action,
) => {
  const key = 'BANNERS';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const sectionDetail = (
  state = {
    isFetching: false,
    path: [],
    articles: {
      articles: [],
      nextOffset: null,
    },
  },
  action,
) => {
  switch (action.type) {
    case ACTION.SECTION_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        articles: action.data.articles,
        locations: action.data.locations,
      });
    case ACTION.SECTION_DETAIL_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.SECTION_DETAIL_MORE_ARTICLES_SUCCESS:
      return Object.assign({}, state, {
        articles: {
          articles: [
            ...state.articles.articles,
            ...action.data.articles.articles,
          ],
          nextOffset: action.data.articles.nextOffset,
        },
      });
    default:
      return state;
  }
};

const feedArticles = (
  state = {
    isFetching: false,
    articles: [],
    nextOffset: null,
  },
  action,
) => {
  switch (action.type) {
    case ACTION.FEED_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        articles: action.shouldConcat ?  [...state.articles, ...action.data.articles] : action.data.articles,
        nextOffset: action.data.nextOffset,
      });
    case ACTION.FEED_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    default:
      return state;
  }
};

const articleDetail = (
  state = {
    isFetching: false,
    related: {
      articles: [],
    },
  },
  action,
) => {
  switch (action.type) {
    case ACTION.ARTICLE_DETAIL_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.ARTICLE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        related: {
          articles: action.data.related,
        },
      });
    default:
      return state;
  }
};

const homeTvKosiceArticle = (
  state = {
    isFetching: false,
    data: [],
  },
  action,
) => {
  switch (action.type) {
    case ACTION.HOME_TVKOSICE_ARTICLE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.HOME_TVKOSICE_ARTICLE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data.map(video => transformTvKosiceVideoToStandardArticle(video)),
      });
    default:
      return state;
  }
};

const homeKosiceonlineArticle = (
  state = {
    isFetching: false,
    data: [],
  },
  action,
) => {
  switch (action.type) {
    case ACTION.HOME_KOSICEONLINE_ARTICLE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case ACTION.HOME_KOSICEONLINE_ARTICLE_SUCCESS:
      if (action.data)      
        return Object.assign({}, state, {
          isFetching: false,
          data: action.data.map(article => ({
            _id: article._id,
            name: article.name,
            date: article.date,
            created: article.created,
            picture: {
              uri: getProp(article, 'picture.uri', null),
            },
            section: {
              name: getProp(article, 'section.name', null),
            },
            url: article.url,
          }))
        });
      return state;
    default:
      return state;
  }
};

const playlistBannerStaticText = (
  state = {
    isFetching: false,
    data: {
      content: null,
      static_content: null,
    },
    receivedAt: null,
  },
  action,
) => {
  const key = 'PLAYLIST_BANNER';
  switch (action.type) {
    case `${key}_REQUEST`:
    case `${key}_SUCCESS`:
    case `${key}_FAILURE`:
      return Object.assign({}, state, xhrRequestReducer(key, state, action));
    default:
      return state;
  }
};

const siteBanners = (
  state = {
    data: {},
  },
  action,
) => {
  switch (action.type) {
    case 'BANNER_FETCH_SUCCESS':
      return Object.assign({}, state, {
        data: Object.assign({}, state.data, {
          [action.data.id]: {
            data: action.data.data,
          },
        }),
      });
    default:
      return state;
  }
};

const calendar = (
  state = {
    locations: [],
    events: {
      isFetching: false,
      byKey: {},
    },
  },
  action,
) => {
  switch (action.type) {
    case ACTION.FETCH_CALENDAR_LOCATIONS_SUCCESS:
      return Object.assign({}, state, {
        locations: action.data,
      });
    case ACTION.FETCH_CALENDAR_EVENTS_REQUEST:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          isFetching: true,
        }),
      });
    case ACTION.FETCH_CALENDAR_EVENTS_FAILURE:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          isFetching: false,
        }),
      });
    case ACTION.FETCH_CALENDAR_EVENTS_SUCCESS: {
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          isFetching: false,
          byKey: Object.assign({}, state.events.byKey, {
            [action.data.key]: action.data.events,
          }),
        }),
      });
    }
    default:
      return state;
  }
};

export default {
  mainmenu,
  footermenu,
  infomixArticles,
  traffic,
  homeTraffic,
  trafficEntities,
  playlist,
  banners,
  sectionDetail,
  feedArticles,
  articleDetail,
  homeTvKosiceArticle,
  homeKosiceonlineArticle,
  playlistBannerStaticText,
  siteBanners,
  calendar
};



// WEBPACK FOOTER //
// ./src/app/reducers.js